import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { OSUpdate as MdmOsUpdate } from '@rocksoft/mdm-sdk-v2';
import type { CategoryAllowedOsUpdate } from '../../types/location-allowed-os-update.types';
import { OsUpdateListItemComponent } from '../os-update-list-item/os-update-list-item.component';

@Component({
  selector: 'era-os-update-list',
  templateUrl: './os-update-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OsUpdateListItemComponent],
})
export class OsUpdateListComponent {
  readonly isEditing = input(false);
  readonly allowEditing = input(false);
  readonly allowSelecting = input(false);
  readonly osupdates = input<(MdmOsUpdate | CategoryAllowedOsUpdate)[]>([]);

  readonly deleted = output<MdmOsUpdate | CategoryAllowedOsUpdate>();
  readonly selectedOsUpdateChange = output<MdmOsUpdate | CategoryAllowedOsUpdate>();

  public selectedOsUpdate: MdmOsUpdate | CategoryAllowedOsUpdate;

  public delete(osupdate: MdmOsUpdate | CategoryAllowedOsUpdate) {
    this.deleted.emit(osupdate);
  }

  public select(selectedOsUpdate: MdmOsUpdate | CategoryAllowedOsUpdate) {
    if (this.selectedOsUpdate !== selectedOsUpdate) {
      this.selectedOsUpdate = selectedOsUpdate;
      this.selectedOsUpdateChange.emit(this.selectedOsUpdate);
    }
  }
}
